<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" size="medium" label-width="100px">
            <el-form-item label="审阅类型" prop="previewType" required>
                <el-radio v-model="form.previewType" :label="1">无意见</el-radio>
                <el-radio v-model="form.previewType" :label="2">需整改</el-radio>
            </el-form-item>
            <el-form-item label="整改内容" v-if="form.previewType==2"  prop="feedbackContent" required>
            <div >
                <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        placeholder="请输入整改意见"
                        v-model="form.feedbackContent">
                </el-input>
            </div>
            </el-form-item>
            <el-row style="padding-top:20px;">
                <div class="dialog-footer" style="padding-left: 40%">
                    <el-button @click="closeDialog()" size="small">关 闭</el-button>
                    <el-button size="small" type="primary" @click="handleClick('form')">确 定</el-button>
                </div>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {addObj} from '@/api/admin/sysMaterialPreview/index';
    export default {
        components: {},
        name: 'preview',
        props:["id","ids"],
        data() {
            return {
                form:{
                    subId: null,
                    subIds: null,
                    previewType: null,
                    feedbackContent: null,
                },
                rules: {
                    previewType: [{
                        required: true,
                        message: '请选择审阅类型',
                        trigger: 'blur'
                    }],feedbackContent: [{
                        required: true,
                        message: '请输入整改意见',
                        trigger: 'blur'
                    }],
                }
            }
        },
        created() {
             if(this.id){
                 this.form.subId = this.id;
             }else if(this.ids && this.ids.length>0){
                 this.form.subIds= this.ids;
             }
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        methods: {
            handleClick:function(formName){
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        addObj(this.form)
                            .then(() => {
                                this.$emit('success')
                                this.$notify({
                                    title: '成功',
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });

            },
            closeDialog(){
                this.$emit('close')
            }
        }
    }
</script>
